import { FilesDB } from "./types";

const cacheTtl = 1000 * 60 * 60 * 24;

function createFileCacheDB(): FilesDB {
  let db: IDBDatabase;
  const request = indexedDB.open("files", 1);

  request.onupgradeneeded = (event) => {
    const target = event.target as IDBRequest;

    db = target.result;

    const objectStore = db.createObjectStore("files", {
      keyPath: "key",
    });

    objectStore.createIndex("blob", "blob", { unique: false });
    objectStore.createIndex("ttl", "ttl");
  };

  request.onsuccess = (event) => {
    const target = event.target as IDBRequest;

    db = target.result;
    console.log("Database opened successfully");
  };

  request.onerror = () => console.error("Database error");

  return {
    add(key: string, blob: Blob) {
      return new Promise<void>((resolve, reject) => {
        const transaction = db.transaction(["files"], "readwrite");
        const objectStore = transaction.objectStore("files");
        const request = objectStore.put({
          key,
          blob,
          ttl: new Date().getTime() + cacheTtl,
        });

        request.onsuccess = () => resolve();

        request.onerror = reject;
      });
    },
    get(key: string): Promise<Blob> {
      return new Promise<Blob>((resolve, reject) => {
        const transaction = db.transaction(["files"], "readonly");
        const objectStore = transaction.objectStore("files");
        const request = objectStore.get(key);

        request.onsuccess = (event) => {
          try {
            const target = event.target as IDBRequest;
            const ttl = target.result.ttl;

            if (new Date().getTime() <= ttl) {
              resolve(target.result.blob);
            } else {
              objectStore.delete(key);
              reject();
            }
          } catch (e) {
            reject(e);
          }
        };

        request.onerror = reject;
      });
    },
    remove(key: string): Promise<void> {
      return new Promise<void>((resolve, reject) => {
        const transaction = db.transaction(["files"], "readwrite");
        const objectStore = transaction.objectStore("files");
        const request = objectStore.delete(key);

        request.onsuccess = () => resolve();
        request.onerror = reject;
      });
    },
  };
}

export type { FilesDB };

export { createFileCacheDB };
